import React from 'react'
import CommonOrder from '../commonorder/CommonOrder'

const FastfarityOrder = () => {
  return (
    <>
     <div>
     <CommonOrder/>
     
  
     </div>
 
     </>
  )
}

export default FastfarityOrder